import { api } from "../api";

/**
 * workScheduleFindAllListResponse - Function that finds on database all activated work schedules as select list
 * /work-schedules/list/{customerId}
 * method GET
 * @async-function
 */
const workScheduleFindAllListResponse = async (token: string, customerId: number) => {
    const response = await api.get(
        `/work-schedules/list/${customerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default workScheduleFindAllListResponse;
